/**
 * Normalise les items initialement passés à CaracteristiquesChips.
 * Accepte :
 * - embed Admin plat : { id, label, miseEnAvant, ordre }
 * - forme Prisma imbriquée : { miseEnAvant, ordre, caracteristique: { id, label } }
 *
 * Rejette volontairement l'embed public (label seul, sans id) —
 * le correctif staff reste optional-auth → toAdminEmbed.
 *
 * Priorité à `caracteristique.id` quand présent, pour ne pas prendre
 * l'id de liaison ProduitCaracteristique à la place de l'id métier.
 */
export function normalizeCaracteristiqueChipItems(initialItems) {
  if (!Array.isArray(initialItems)) return [];
  return initialItems
    .map((it) => {
      if (!it || typeof it !== 'object') return null;

      let id = null;
      let label = null;
      if (it.caracteristique?.id && it.caracteristique?.label) {
        id = it.caracteristique.id;
        label = it.caracteristique.label;
      } else if (it.id && it.label) {
        id = it.id;
        label = it.label;
      } else {
        return null;
      }

      return {
        id,
        label,
        miseEnAvant: Boolean(it.miseEnAvant),
        ordre: it.ordre ?? 0,
      };
    })
    .filter(Boolean)
    .sort((a, b) => (a.ordre ?? 0) - (b.ordre ?? 0));
}
